export default "__VITE_ASSET__RowuLOHE__"